import { render, staticRenderFns } from "./GoToMasterExercise.vue?vue&type=template&id=6bce846c&lang=pug&"
import script from "./GoToMasterExercise.vue?vue&type=script&lang=ts&"
export * from "./GoToMasterExercise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports